<template>
  <ModalDialog
    ref="dialog"
    title="Search Sheet"
    icon="fa-search"
    sizeClass="modal-med"
    :showFooter="true"
    closeTitle="Cancel"
    submitTitle="Search"
    :submitDisabled="!canSubmit"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3" @submit="onFormSubmitted">
      <FormRow label="Search">
        <FormInputText ref="searchEntry" placeholder="Search Text" v-model="searchText" note="Enter barcode, order number or contact name to find on the sheet" @enter="onSubmitted" />
      </FormRow>

    </FormGroup>
  </ModalDialog>
</template>

<style scoped>

</style>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import { SheetAllocationTypes } from '@/store/types'

export default {
  name: 'OptimiserSheetSearchDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    optimiserSheet: Object
  },
  computed: {
    canSubmit() {
      return this.searchText != ''
    }
  },
  data() {
    return {
      form: {},
      searchText: ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchEntry.select()
      this.$refs.searchEntry.focus()
    })
  },
  methods: {
    show() {

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted(ev) {
      this.form = this.clearFormResponse()

      let searchText = (this.searchText || '').toUpperCase().trim()
      let searchMatchFn = (text) => {
        return (text || '').toUpperCase().trim().includes(searchText)
      }

      let allocationList = this.optimiserSheet.optimiserSheetAllocations || []
      let selectedList = allocationList.filter(alloc => {
        if(alloc.type == SheetAllocationTypes.panel) {
          if(alloc.productionPanel && searchMatchFn(alloc.productionPanel.barcode))
            return true
          if(searchMatchFn(alloc.order.sequenceNumber))
            return true
          if(alloc.order.contact && searchMatchFn(alloc.order.contact.name))
            return true
        }
        if(alloc.type == SheetAllocationTypes.offcut) {
          if(alloc.glassLevel && searchMatchFn(alloc.glassLevel.barcode))
            return true
        }

        return false
      })

      if(selectedList.length == 0) {
        this.form.errorMessage = 'No items found in the sheet'
        return
      }

      this.modalClosed(selectedList)
      this.hide()
    },
    onFormSubmitted(ev) {
      ev.preventDefault()
    }
  }
}
</script>